// Analytics utility functions for SpeakRoots V1
import { trackEvent as firebaseTrackEvent } from '../api/firebase';
import logger from './logger';

// Google Analytics 4 configuration
const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

// Initialize Google Analytics 4
export const initializeGA4 = () => {
    if (typeof window !== 'undefined' && GA4_MEASUREMENT_ID) {
        // Load Google Analytics script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
        document.head.appendChild(script);

        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', GA4_MEASUREMENT_ID, {
            page_title: document.title,
            page_location: window.location.href,
        });
    }
};

// Track page views
export const trackPageView = (pageName, pagePath) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA4_MEASUREMENT_ID, {
            page_title: pageName,
            page_location: window.location.href,
            page_path: pagePath,
        });
    }
};

// Track custom events
export const trackGA4Event = (eventName, parameters = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, {
            event_category: parameters.category || 'User Interaction',
            event_label: parameters.label,
            value: parameters.value,
            ...parameters
        });
    }
};

// Enhanced tracking function that sends to both Firebase and GA4
export const trackEvent = async (eventName, parameters = {}) => {
    try {
        // Send to Firebase Analytics
        await firebaseTrackEvent(eventName, parameters);
        
        // Send to Google Analytics 4
        trackGA4Event(eventName, parameters);
        
        // Log for debugging
        logger.info('ANALYTICS', 'Info', parameters);
    } catch (error) {
        logger.error('ANALYTICS', 'Error', error);
    }
};

// User properties
export const setUserProperties = (properties) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA4_MEASUREMENT_ID, {
            user_properties: properties
        });
    }
};

// E-commerce tracking
export const trackPurchase = (transactionId, value, currency = 'USD', items = []) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'purchase', {
            transaction_id: transactionId,
            value: value,
            currency: currency,
            items: items
        });
    }
};

// Conversion tracking
export const trackConversion = (conversionType, value = null) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'conversion', {
            send_to: `${GA4_MEASUREMENT_ID}/${conversionType}`,
            value: value,
            currency: 'USD'
        });
    }
};

export default {
    initializeGA4,
    trackPageView,
    trackEvent,
    setUserProperties,
    trackPurchase,
    trackConversion
};
